export default {
  baseURL: "http://localhost:8080"
};
